import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { lessonTypeLabel, lessonTimeLabel, polishDate } from './clientPortalSelectors';

export default function LessonCard({ lesson, lessonTypes, disabled, confirming, onRequest, onDismiss, onConfirm, onUndo }) {
  const actionRef = useRef(null);
  const cancelled = lesson.lessonStatus === 'cancelled';
  const participation = { cancelledOnTime: 'Udział odwołany w terminie', cancelledLate: 'Udział odwołany po terminie', cancelled: 'Udział odwołany' }[lesson.participationStatus];
  const dismiss = () => { onDismiss(); if (actionRef.current) actionRef.current.focus(); };
  const closeConfirmation = event => { if (event.key === 'Escape' && !disabled) dismiss(); };
  return (
    <article className="client-portal__lesson-card">
      <div className="client-portal__lesson-date">{polishDate(lesson.date, true)}</div>
      <div className="client-portal__lesson-time">{lessonTimeLabel(lesson, lessonTypes)}</div>
      <div className="client-portal__lesson-type">{lessonTypeLabel(lesson.classTypeId, lessonTypes)}</div>
      <div>{lesson.studentName}</div>
      {cancelled && <p className="client-portal__status">Lekcja odwołana</p>}
      {!cancelled && participation && <p className="client-portal__status">{participation}</p>}
      <div className="client-portal__lesson-actions">
        {lesson.canCancel && <button ref={actionRef} type="button" className="btn btn-outline-secondary" disabled={disabled} onClick={confirming ? dismiss : onRequest}>Zgłoś nieobecność</button>}
        {lesson.canUndoCancellation && <button type="button" className="btn manage-teal-button" disabled={disabled} onClick={onUndo}>Cofnij odwołanie</button>}
      </div>
      {confirming && (
      <div className="client-portal__confirmation" role="group" aria-label="Potwierdzenie odwołania">
        <p>{lesson.cancellationEligibility && lesson.cancellationEligibility.message}</p>
        <div className="client-portal__lesson-actions">
          <button type="button" className="btn manage-teal-button" disabled={disabled} onKeyDown={closeConfirmation} onClick={dismiss}>Anuluj</button>
          <button type="button" className="btn manage-red-button" disabled={disabled} onKeyDown={closeConfirmation} onClick={onConfirm}>Potwierdzam odwołanie</button>
        </div>
      </div>
      )}
    </article>
  );
}
LessonCard.propTypes = {
  lesson: PropTypes.object.isRequired,
  lessonTypes: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  confirming: PropTypes.bool.isRequired,
  onRequest: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
};
